var PgView = require('../page'),
    IframeView = require('../urlFrame'),
    DocModePg = require('../docMode/pageDocMode'),
    PageErrorView = require('../error/view');


module.exports = PgView.extend({

    className: 'FV-pgWr FV-pgWr-url', // TODO: inherit ... ( get rid of set element )

    APPLY_TRANSFORM: 0, // hack flag --  could make more generic

    initialize: function(options) {

        _.extend( this, _.pick(options, 'model', 'vChannel', 'scale') );

        this.imgView = new IframeView(options);

    },
    /**
     *  Need the 'inView call' for DocMode -- could also apply in viewMode change callback
     *  Do even if page mode, because won't be able to get its view mode easily onRender
     */
    onRender:  DocModePg.prototype.onRender,

    serializeData: function() {

        return _.extend( PgView.prototype.serializeData.call(this), {
            printWithDummyDimensions: false, // it does have unknown dims, but don't display unnecessary markup
            excludeCanvasStub: true
        });

    },

    // TODO: more consolidation ... put the code after isLoaded into separate function
    requestImg: function() {

        var pm = this.model,
            imgView = this.imgView;

        pm.off('creRequest');
        this.triggerMethod('before:ImageRequest');

        if ( !pm.get('isLoaded') ) { // use this or a param for the 're-render' hack
            pm.set({wasRequested: true}); // --> enter loading state ( show spinner, etc )
            imgView.loadImg( pm.getPageUrl() );
        }

    },

    /**
     * IMPORTANT: unable to determine if from XFRAME-options -- user will prob never see this -- it will just fail hard.
     * Would require endpoint in server to parse http header.
     * I don't think Tom allowed me to do this ... not used ... maybe I could implement later on server.
     * Put in the transformedWr because placeholder may have already been removed ..
     * here, an error can occur after a successful load.
     * Note: there is no CRE request going on here.
     * TODO: the loading cycle here is different; clean up and use what is common.
     * Note -- this is called from urlFrame and is commented out for the time being -- related to DVBC-1703.
     */
    _appendErrorViewInDOM: function(errMsg) {

        this.ui.placeHolder.length > 0 &&
            this.ui.placeHolder.remove();

        var urlLoadingErr = !errMsg;

        var errMsg = urlLoadingErr
            ? 'Error Loading URL.\n It may exist on a server set with X-FRAME-OPTIONS="SAMEORIGIN."' //this is a non 'cre loading error' .... now for handling xframe
            : _.isString(errMsg) ? errMsg : 'Error Loading URL';  //would this ever occur actually ?


        this.errorView = new PageErrorView({
            errMsg: errMsg
        });

        // Note: transform wr is not transformed here
        this.ui.transformedWr.append( this.errorView.render().el );

        // this would need to be appended to to the initial view

        if (urlLoadingErr) {

            //very quick imple. -- should make template and/or part/extenstion of the error view
            var url = this.model.get('url');
            var $lnk = $('<a>')
                .attr('href', url)
                .attr('target', '_blank')
                .text(url)
                .attr('title', 'Open In New Window');

            this.$('.pageErrBody').append( $('<div>')
                .css({
                    'margin-top': '15px',
                    'line-height': '1.5em'
                 })
                .append('Click below to try opening in it in a new window ')
                .append( $('<i>').attr('class', 'icon icon-link-ext-alt') )
                .append('<br>')
                .append( $lnk) );

        }

    },
    onBeforeDestroy: function() {

        DocModePg.prototype.onBeforeDestroy.apply( this, arguments );

        // need to investigate why doc mode page view didn't call destroy of super ( and calling this here )
        this.errorView && this.errorView.destroy();

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/url/view.js
 ** module id = 455
 ** module chunks = 0
 **/